import { PLACE_TYPE_META, type PlaceType, type Pricing } from "~/lib/api";
import { cn } from "~/lib/utils";

interface PlaceTypeLabelProps {
  type: PlaceType;
  pricing?: Pricing | null;
  className?: string;
}

export function PlaceTypeLabel({ type, pricing, className }: PlaceTypeLabelProps) {
  return (
    <span className={cn("text-xs font-medium text-primary uppercase tracking-wide", className)}>
      {PLACE_TYPE_META[type].label}
      {pricing?.free && " · Free"}
    </span>
  );
}
